import Vue from "vue";
import Navigation from "./components/navigation-component";
import Footer from "./components/footer-component";
import CMSBar from "./components/cms-bar-component";
import router from "./routes";
import store from "./store";
import VueRouter from "vue-router";
import Plugins from "./plugins";
import VueAnalytics from "vue-analytics";
import VueLazyload from "vue-lazyload";
import VueHead from "vue-head";
import vueEventCalendar from "vue-event-calendar";
import Moment from "moment";
import _find from "lodash/find";
import "vue-event-calendar/dist/style.css";
import TweenMax from "gsap/TweenMax";
import * as VueGoogleMaps from "vue2-google-maps";
import './directives'
import './filters/filters'

window.moment = Moment;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBSvehXF_OTQOyCO9R2FsajNRHnDD4Xg5w",
  },
});

Vue.use(vueEventCalendar, {
  locale: "fr",
  color: "#D33741",
  weekStartOn: 1,
});
Vue.use(VueHead);
Vue.use(VueRouter);
Vue.use(Plugins);
Vue.use(VueLazyload);
Vue.use(VueAnalytics, {
  id: "UA-125192634-1",
  router,
});

window.axios = require("axios");

new Vue({
  el: "#app",
  router,
  store,
  data() {
    return {
      sections: [],
      playerInfoOpen: false,
      newsYearsOnly: [],
      juniorsSubCategory: null,
      documentsOpen: false,
    };
  },
  template: `
	<div id="app" v-if="sections.length">
		<cms-bar></cms-bar>
		<navigation :propSections="sections"></navigation>
		<transition v-on:enter="enter" v-on:afterEnter="afterEnter" v-on:before-leave="beforeLeave" v-on:leave="leave" v-on:before-enter="beforeEnter" appear mode="out-in">
			<router-view :key="$route.params.sectionSlug"></router-view>
		</transition>
		<footer-component v-if="section.type == 'home'"></footer-component>
	</div>`,
  components: {
    cmsBar: CMSBar,
    navigation: Navigation,
    footerComponent: Footer,
  },
  created: function() {
    document.title = "Lancy FC Club de Football";
    this.getData();
  },
  watch: {
    $route: function() {
      window.scroll(0, 0);
      this.playerInfoOpen = false;
      this.juniorsSubCategory = null;
      this.documentsOpen = false;
    },
  },
  methods: {
    getData() {
      var self = this;

      axios
        .all([
          this.getAllSections(),
          this.getPages(),
          this.getTeams(),
          this.getTeamsWithCategories(),
        ])
        .then(
          axios.spread((sections, pages, teams, teamsWithCategories) => {
            let sectionsCopy = sections.data;
            let _sections = [];
            sectionsCopy.forEach(function(section, i) {
              section.index = i;
            });

            for (let s of sectionsCopy) {
              _sections.push(s);
              if (s.children) {
                for (let child of s.children) {
                  _sections.push(child);
                  if (child.children) {
                    for (let _child of s.children) {
                      _sections.push(_child);
                    }
                  }
                }
              }
            }

            this.sections = sectionsCopy;
            this.$store.commit("sections", _sections);
            this.$store.commit("allSections", _sections);
            this.$store.commit("pages", pages.data);
            this.$store.commit("teams", teams.data);
            this.$store.commit("teamsWithCategories", teamsWithCategories.data);
          })
        );
    },
    getAllSections() {
      return axios.get("/fr/api/v2/sections/full");
    },
    getPages() {
      return axios.get("/fr/api/v2/pages");
    },
    getTeams() {
      return axios.get("/api/v2/teams");
    },
    getTeamsWithCategories() {
      return axios.get("/api/v2/teamcategories");
    },
    beforeEnter: function(el) {},
    enter: function(el, done) {
      done();
    },
    afterEnter: function(el) {},
    beforeLeave: function(el) {},
    leave: function(el, done) {
      done();
    },
  },
  computed: {
    section() {
      return _find(this.sections, { slug: this.$route.params.sectionSlug });
    },
  },
});
